import { useContext, useEffect, useState } from 'react'
import { Loader } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { getFileTypeFromName } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import UnsupportedFile from '../../../unsuported_file/UnsupportedFile'
import styles from './FileViewer.module.scss'

export const FileViewer = ({ file }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [fileUrl, setFileUrl] = useState(null)
  const [fileType, setFileType] = useState(null)
  const [loading, setLoading] = useState(false)
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const loadFile = () => {
    try {
      if (file && file.fileUrl) {
        const url = file.fileUrl[currentLanguage]
        const filename = file.filename[currentLanguage]
        setFileUrl(url)
        const fileType = getFileTypeFromName(filename)
        setFileType(fileType)
      }
    } catch (error) {
      // Handle any errors
    }
  }

  useEffect(() => {
    setLoading(true)
    loadFile()
    setLoading(false)
  }, [file, currentLanguage])

  const renderContent = () => {
    if (loading) return <Loader />

    switch (fileType) {
      case 'image':
        return <img className={styles['image']} src={fileUrl} alt={t('main.fileViewer')} />
      default:
        return <UnsupportedFile />
    }
  }

  useEffect(() => {
    setHeaderLabel(t('main.fileViewer'))
    setBtns([{ text: t('buttons.close'), onClick: onClose }])
  }, [])

  return <div className={styles['container']}>{renderContent()}</div>
}
